export default "__VITE_ASSET__84988c32__"